import { Controller } from "stimulus"
import "tom-select/dist/css/tom-select.css"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    if (!this.element.tomselect) {
      const defaultOptions = {
        plugins: ['remove_button'],
        sortField: 'text',
        maxOptions: 10000,
        dropdownParent: 'body'
      };

      let customOptions = {};
      try {
        const optionsAttr = this.element.getAttribute('data-options');
        if (optionsAttr) {
          customOptions = JSON.parse(optionsAttr);
        }
      } catch (e) {
        console.error('Error parsing tom-select options:', e);
      }
      
      if (this.element.getAttribute('data-create') === 'true') {
        customOptions.create = true;
        customOptions.persist = false;
        customOptions.createOnBlur = true;
      }

      if (this.element.dataset.loadUrl !== undefined) {
        customOptions.loadThrottle = 300;
        customOptions.score = () => () => 1;
        customOptions.shouldLoad = (query) => query.length >= 2 && !!this.element.dataset.loadUrl;
        customOptions.load = (query, callback) => {
          const url = new URL(this.element.dataset.loadUrl, window.location.origin);
          url.searchParams.set('q', query);
          fetch(url, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((options) => { this.element.tomselect.clearOptions(); callback(options); })
            .catch(() => callback());
        };
      }

      const options = { ...defaultOptions, ...customOptions };
      
      new TomSelect(this.element, options);
    }
  }
}
